import Vue from 'vue'
import Router from 'vue-router'

import mobileRouter from './modules/mobileRouter'
import windowRouter from './modules/windowRouter'
import {
  getType
} from '../assets/js/pcMobile.js'

Vue.use(Router)

let roule = []
let flag = getType()

editRouter();
window.onresize = function() {
  editRouter();
};

function editRouter() {
  let flag = getType()
  var bodyWidth = document.documentElement.clientWidth; // 当前窗口的宽度
  if (bodyWidth >= 980) {
    roule = windowRouter
  } else {
    roule = mobileRouter
  }
  // if (flag == 'pc') {
  //   if (bodyWidth >= 980) {
  //     roule = windowRouter
  //   } else {
  //     roule = mobileRouter
  //   }
  // } else {
  //   roule = mobileRouter
  // }
}

// if (bodyWidth >= 1366) {
//   roule = windowRouter
// } else {
//   roule = mobileRouter
// }
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: roule,
  editRouter
})



// WEBPACK FOOTER //
// ./src/router/index.js